import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';

const useVerifyOTP = ({ verifyFn, setVerified, redirectTo = null }) => {
  const navigate = useNavigate();

  const { mutate: otpMutation, isPending } = useMutation({
    mutationFn: verifyFn,
    onSuccess: () => {
      toast.success('OTP verified successfully', {
        autoClose: 3000,
        className:
          'bg-[var(--yellow-primary)] text-black text-sm px-2 py-2 rounded-md',
        closeButton: false,
      });

      if (redirectTo) {
        // Redirect user to provided route (e.g., login or verify-email page)
        navigate(redirectTo);
      } else if (setVerified) {
        // Stay on page and mark as verified
        setVerified(true);
      }
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Verification failed', {
        autoClose: 3000,
        className:
          'bg-[var(--yellow-primary)] text-black text-sm px-2 py-2 rounded-md',
        closeButton: false,
      });

      if (setVerified) setVerified(false);
    },
  });

  return { otpMutation, isPending };
};

export default useVerifyOTP;
